import { createSlice } from '@reduxjs/toolkit';

// types
interface Button {
    text?: string;
    color?: string;
    sx?: any;
}
interface ButtonTypeProps {
    cancel?: Button,
    submit?: Button,
    dismiss?: Button,
}
interface CallbackProps {
    status?: number;
    str?: string;
}

export interface FormDialogProps {
    open: boolean;
    callback(str?: CallbackProps): void;
    title?: string| React.ReactNode;
    description?: string | React.ReactNode;
    button?: ButtonTypeProps;
    inputLabel?: string;
    inputType?: string;
}

const initialState: FormDialogProps = {
    open: false,
    title: 'Are you sure?',
    description: undefined,
    inputLabel: undefined,
    inputType: undefined,
    button: undefined,
    callback: () => {}
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const confirmDialog = createSlice({
    name: 'confirmDialog',
    initialState,
    reducers: {
        openDialog(state, action) {
            const { open, title, description, inputLabel, inputType, callback, button } = action.payload;

            state.open = open ?? initialState.open;
            state.title = title ?? initialState.title;
            state.description = description ?? initialState.description;
            state.inputLabel = inputLabel ?? initialState.inputLabel;
            state.inputType = inputType ?? initialState.inputType;
            state.callback = callback || undefined;
            state.button = button ?? initialState.button;
        },

        closeDialog(state) {
            state.open = false;
        }
    }
});

export default confirmDialog.reducer;

export const { closeDialog, openDialog } = confirmDialog.actions;
